import { assert } from '@core/prelude';

type MenuItemActionType = 'link' | 'function';

export class MenuItem {
  name: string;
  action: string | (() => void);
  selected: boolean;
  paramName: string | null = null;

  constructor(
    name: string,
    action: string | (() => void),
    selected: boolean = false,
    paramName: string | null = null
  ) {
    this.name = name;
    this.action = action;
    this.selected = selected;
    this.paramName = paramName;
  }

  get actionType(): MenuItemActionType {
    return typeof this.action == 'string' ? 'link' : 'function';
  }

  get href(): string {
    assert(
      typeof this.action == 'string',
      'Internal error: Accessing href of MenuItem which is not a link'
    );
    return this.action;
  }

  get onClick(): () => void {
    assert(
      typeof this.action != 'string',
      'Internal error: Accessing onClick of MenuItem which is not a function'
    );
    return this.action;
  }
}
